import React from 'react'
import CanadaTemplateRedirect from 'src/components/template/ca/redirect'
export default (props) => <CanadaTemplateRedirect location={props.location} />
